import throttle from "utils/throttle"
import "./index.scss"
import "./static/background.mp4"
import "./static/background.webp"
import "./static/unlock-white.svg"
import "./static/unlock-black.svg"

const bemBlock = "rewards-header__"
const height = document.querySelector(`.${bemBlock}sticky-block`)

function setHeight() {
  document.querySelector(
    `.${bemBlock}sticky-space-filler`,
  ).style.height = `${height.offsetHeight}px`
}
export default function run() {
  if (!height) {
    return
  }
  if (window.matchMedia("(max-width: 940px)").matches === false) {
    setHeight()
    window.addEventListener("resize", throttle(setHeight, 500))
  }
}
